export default "__VITE_ASSET__gmNTdky2__"